export default "__VITE_ASSET__CmXa3R$v__"